<form-popup
  [titleText]="'auth.titulos.changePassword' | translate"
  [visible]="visible"
  [width]="360"
  [height]="410"
  [wrapperAttr]="{ class: 'change-profile-password-popup' }"
  [isSaveDisabled]="isSaveDisabled"
  (save)="saveNewPassword()"
  (visibleChange)="changeVisible($event)"
>
  <dx-form
    #form
    labelMode="outside"
    labelLocation="top"
    [showColonAfterLabel]="true"
  >
    <dxi-item>
      <dxo-label [text]="'crmContacts.actions.oldPassword' | translate"></dxo-label>
      <password-text-box
        stylingMode="filled"
        [(value)]="formData['currentPassword']"
        (valueChanged)="onFieldChanged()"
      ></password-text-box>
    </dxi-item>

    <dxi-item>
      <div class="h-separator"></div>
    </dxi-item>

    <dxi-item>
      <dxo-label [text]="'crmContacts.actions.newPassword' | translate"></dxo-label>
      <password-text-box
        stylingMode="filled"
        [(value)]="formData['password']"
        (valueChanged)="onNewPasswordChanged()"
      ></password-text-box>
    </dxi-item>

    <dxi-item>
      <dxo-label [text]="'crmContacts.actions.confirmNewPassword' | translate"></dxo-label>
      <password-text-box
        #confirmField
        stylingMode="filled"
        [(value)]="formData['confirmedPassword']"
        [validators]="confirmPasswordValidators"
        (valueChanged)="onFieldChanged()"
      >
      </password-text-box>
    </dxi-item>
  </dx-form>
</form-popup>
